import { createTheme } from "@material-ui/core/styles";

const baseTheme = createTheme({
  breakpoints: { values: { xs: 0, sm: 600, md: 960, lg: 1280, xl: 1920 } },
});

const theme = createTheme({
  overrides: {
    MuiPaper: {
      rounded: {
        borderRadius: 24,
        overflow: "hidden !important",
      },
    },
    MuiPopover: {
      paper: {
        // Rounded Paper is globally clipped for cards, but popovers and menus
        // need their own scroll container to keep long option lists usable.
        "&.MuiPaper-rounded": {
          overflowY: "auto !important",
          overflowX: "hidden !important",
        },
      },
    },
    MuiMenu: {
      paper: {
        "&.MuiPaper-rounded": {
          overflowY: "auto !important",
          overflowX: "hidden !important",
        },
      },
    },
    MuiOutlinedInput: {
      root: {
        borderRadius: 12,
      },
    },
    MuiButton: {
      root: {
        textTransform: "none",
        fontWeight: 800,
        letterSpacing: ".02em",
        borderRadius: 16,
        padding: "10px 20px",
      },
      sizeLarge: {
        fontSize: "0.95rem",
        padding: "14px 28px",
        minHeight: 52,
      },
      containedSecondary: {
        color: "#0E0F0C",
      },
      outlinedSecondary: {
        borderColor: "rgba(149, 227, 98, 0.6)",
      },
    },
    MuiCard: {
      root: {
        overflow: "hidden",
        borderRadius: 24,
      },
    },
    MuiTypography: {
      gutterBottom: {
        marginBottom: ".55em",
      },
      h1: {
        fontFamily: ["Sequel Sans", "sans-serif"].join(","),
        fontWeight: 415,
        fontSize: "72px",
        lineHeight: "0.98",
        letterSpacing: "-.02em",
        [baseTheme.breakpoints.down("md")]: {
          fontSize: "44px",
        },
      },
      h2: {
        fontFamily: ["Sequel Sans", "sans-serif"].join(","),
        fontWeight: 410,
        fontSize: "52px",
        lineHeight: "1.05",
        letterSpacing: "-.02em",
        [baseTheme.breakpoints.down("md")]: {
          fontSize: "34px",
        },
      },
      h3: {
        fontFamily: ["Sequel Sans", "sans-serif"].join(","),
        fontWeight: 420,
        fontSize: "30px",
        lineHeight: "1.1",
        letterSpacing: "-.02em",
        [baseTheme.breakpoints.down("md")]: {
          fontSize: "24px",
        },
      },
      h4: {
        fontFamily: ["Sequel Sans", "sans-serif"].join(","),
        fontWeight: 800,
      },
      h5: {
        fontFamily: ["Sequel Sans", "sans-serif"].join(","),
        fontWeight: "normal",
        fontSize: "1.4rem",
      },
      body1: {
        fontSize: "16px",
        lineHeight: 1.6,
      },
      body2: {
        fontSize: "14px",
        lineHeight: 1.55,
      },
    },
    MuiTablePagination: {
      root: {
        float: "left",
      },
    },
    MuiAlert: {
      standardInfo: {
        backgroundColor: "rgba(1, 54, 46, 0.1)",
        color: "#01362E",
        "& .MuiAlert-icon": {
          color: "rgba(1, 54, 46, 0.6)",
        },
      },
    },
  },
  shape: {
    borderRadius: 24,
  },
  palette: {
    text: {
      primary: "#0E0F0C",
      secondary: "rgba(14, 15, 12, 0.7)",
      white: "#FEFEFE",
      grey: "#A8AAA6",
    },
    primary: {
      light: "#03594C",
      main: "#01362E",
      dark: "#012922",
      contrastText: "#FEFEFE",
    },
    secondary: {
      light: "#A6F075",
      main: "#95E362",
      dark: "#6BB02F",
      contrastText: "#0E0F0C",
    },
    green1: {
      main: "#A6F075",
    },
    green2: {
      main: "#95E362",
    },
    green3: {
      main: "#6BB02F",
    },
    green4: {
      main: "#4D8B28",
    },
    success: {
      main: "#95E362",
    },
    grey: {
      main: "#F4F4F6",
      light: "#ECEEF0",
      dark: "#11120E",
    },
    white: {
      main: "#FEFEFE",
      pure: "#FFFFFF",
    },
    gradient: {
      main: "linear-gradient(120deg, #01362E 0%, #03594C 52%, #95E362 100%)",
    },
    error: {
      main: "#FF4C4B",
      light: "#E96363",
      dark: "#360111",
    },
  },
  typography: {
    fontFamily: ["Sequel Sans", "sans-serif"].join(","),
  },
});

export default theme;
